import { useReduxState } from 'hooks';
import { getFileType } from 'lib/files';
import { ApiDownloadButton, ContentBox } from 'components/common';
import { Icon } from 'components/common/icons';

import type { ButtonSize } from 'components/common/Button';

interface Props {
  fileUrl: string;
  font?: string;
  fontSize?: 'small' | 'medium' | 'large' | 'huge';
  title?: string;
}

const ReaderBlockFileContent = ({
  fileUrl,
  font,
  fontSize = 'medium',
  title
}: Props) => {
  const { messages, theme } = useReduxState();

  const { icon, iconColor } = getFileType({
    defaultColor: theme.textColor,
    url: fileUrl
  });

  return (
    <ContentBox>
      <div className="content">
        <a
          className="link"
          href={fileUrl}
          rel="noopener noreferrer"
          style={{
            fontSize: {
              small: '1.4rem',
              medium: '1.5rem',
              large: '1.6rem',
              huge: '1.8rem'
            }[fontSize]
          }}
          target="_blank"
        >
          <div className="icon">
            <Icon
              icon={icon}
              style={{
                color: iconColor,
                fontSize: {
                  small: '1.6rem',
                  medium: '1.8rem',
                  large: '2rem',
                  huge: '2.2rem'
                }[fontSize],
                position: 'relative',
                top: {
                  small: 1,
                  medium: 1,
                  large: 1,
                  huge: 1
                }[fontSize]
              }}
            />
          </div>

          <div className="title" style={{ fontFamily: font || 'inherit' }}>
            {title || fileUrl.slice(fileUrl.lastIndexOf('/') + 1)}
          </div>
        </a>

        <div className="download">
          <ApiDownloadButton
            category="default"
            external={true}
            filename={fileUrl.slice(fileUrl.lastIndexOf('/') + 1)}
            icon="download"
            url={fileUrl}
            size={
              {
                small: 'small',
                medium: 'small',
                large: 'medium',
                huge: 'large'
              }[fontSize] as ButtonSize
            }
            text={messages.commonDownload}
          />
        </div>

        <style jsx>{`
          .content {
            align-items: center;
            display: flex;
            gap: 20px;
            justify-content: space-between;
          }
          .link {
            color: inherit;
            display: inline-flex;
            font-size: inherit;
            font-weight: 600;
            gap: 10px;
            text-decoration: none;
            word-break: break-all;
          }
          .link:focus,
          .link:hover {
            text-decoration: underline;
          }
          .title {
            flex-grow: 1;
            text-align: left;
          }
          .download {
            flex-grow: 0;
            flex-shrink: 0;
            margin: -5px 0;
            min-width: 120px;
            text-align: right;
          }
        `}</style>
      </div>
    </ContentBox>
  );
};

export default ReaderBlockFileContent;
